/* eslint-disable @typescript-eslint/no-namespace */
namespace Account {
    const Simple = require('./simple')

    class Account extends Simple {

        constructor(debug?: boolean) {
            super('Account', debug);
            this.log('Init');
            $(function () {
                $('a.logIn').on('click', e => {
                    e.preventDefault();
                    $('.loginModal-register-form').hide();
                    $('.loginModal-signIn-form').show();
                    ($('#login-modal') as any).modal('show');
                });
                if (window.location.pathname !== '/Account/ResetPassword') {
                    $('.loginModal-register-form').hide();
                    $('.loginModal-signIn-form').show();
                    ($('#login-modal') as any).modal('show');
                }
            });
            const infoCircle = $('i.fa-info-circle');

            infoCircle.on('mouseenter', e => {
                $(e.target).parent().parent().find('.passLabelInfo-info').css({ 'opacity': '1', 'z-index': '1502' });
            });
            infoCircle.on('mouseout', e => {
                $(e.target).parent().parent().find('.passLabelInfo-info').css({ 'opacity': '0', 'z-index': '-1' });
            });
        }

        defaultOnLogin() {
            if (window.location.pathname == '/Account/ResetPassword') {
                window.location.href = '/';
                return;
            }
            sessionStorage.removeItem('userLeadsGridViewPageSize');
            sessionStorage.removeItem('gvLeadsPoolPageSize');

            let url = this.GetParameterByName('ReturnUrl');
            url = url ?? '/home';
            window.location.href = url;
        }
    }

    const app = new Account(true);

}